export const dataHooks = {
    innerContent: 'floating-helper-inner-content',
    closeButton: 'floating-helper-close-button',
    contentWrapper: 'floating-helper-content-wrapper',
};
export const floatingHelperSkin = {
    dark: 'dark',
    light: 'light',
};
export const appendToOptions = {
    scrollParent: 'scrollParent',
    viewport: 'viewport',
    window: 'window',
};
export const placementOptions = {
    autoStart: 'auto-start',
    auto: 'auto',
    autoEnd: 'auto-end',
    topStart: 'top-start',
    top: 'top',
    topEnd: 'top-end',
    rightStart: 'right-start',
    right: 'right',
    rightEnd: 'right-end',
    bottomStart: 'bottom-start',
    bottom: 'bottom',
    bottomEnd: 'bottom-end',
    leftEnd: 'left-end',
    left: 'left',
    leftStart: 'left-start',
};
//# sourceMappingURL=constants.js.map